/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type companiesToBeDeleted_viewer$ref = any;
export type companiesToBeDeleted_QueryVariables = {||};
export type companiesToBeDeleted_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: companiesToBeDeleted_viewer$ref,
  |}
|};
export type companiesToBeDeleted_Query = {|
  variables: companiesToBeDeleted_QueryVariables,
  response: companiesToBeDeleted_QueryResponse,
|};
*/


/*
query companiesToBeDeleted_Query {
  viewer {
    actualPersonId
    component(name: "control_companies_to_be_deleted")
    ...companiesToBeDeleted_viewer
    id
  }
}

fragment companiesToBeDeleted_viewer on Viewer {
  id
  actualPersonId
  missionControlData {
    id
    companiesToBeDeleted {
      id
      companyId
      createdAt
      updatedAt
      name
      trialEndDate
      lastSessionDate
      projectCount
      userCount
      flaggedForDeletionDate
      domains
      toBeDeleted
      sisenseUserCount
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "control_companies_to_be_deleted"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"control_companies_to_be_deleted\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "companiesToBeDeleted_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "companiesToBeDeleted_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "companiesToBeDeleted_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlCompanyToBeDeletedType",
                "kind": "LinkedField",
                "name": "companiesToBeDeleted",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "trialEndDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastSessionDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "flaggedForDeletionDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "domains",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "toBeDeleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sisenseUserCount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "companiesToBeDeleted_Query",
    "operationKind": "query",
    "text": "query companiesToBeDeleted_Query {\n  viewer {\n    actualPersonId\n    component(name: \"control_companies_to_be_deleted\")\n    ...companiesToBeDeleted_viewer\n    id\n  }\n}\n\nfragment companiesToBeDeleted_viewer on Viewer {\n  id\n  actualPersonId\n  missionControlData {\n    id\n    companiesToBeDeleted {\n      id\n      companyId\n      createdAt\n      updatedAt\n      name\n      trialEndDate\n      lastSessionDate\n      projectCount\n      userCount\n      flaggedForDeletionDate\n      domains\n      toBeDeleted\n      sisenseUserCount\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7dea48aa32756191de58dae50215f1e5';

module.exports = node;
